import React, { useRef, useLayoutEffect, useMemo } from 'react'
import cn from 'classnames'
import { pdfjs, Page, Document } from 'react-pdf/dist/esm/entry'
import classes from '../style/index.styl'


export interface ViewerProps {
  /**
   * pdf 文件的 url
   */
  fileUrl: string
  /**
   * 渲染的页号
   */
  pageNumber: number
  /**
   * 页数
   */
  pageTotal: number
  /**
   * 缩放比例
   */
  scale: number
  /**
   * Function called in case of an error while loading a document.
   */
  onLoadError?: (error: Error) => void
  /**
   * Function called when the document is successfully loaded.
   */
  onDocumentLoadSuccess?: (pdf: pdfjs.PDFDocumentProxy) => void
}


export function Viewer(props: ViewerProps): React.ReactElement {
  const { fileUrl, pageTotal, pageNumber, scale } = props
  const containerRef = useRef<HTMLDivElement>(null)

  const pages = useMemo<React.ReactElement[]>(() => {
    const newPages: React.ReactElement[] = []
    for (let i = 1; i <= pageTotal; ++i) {
      newPages.push(
        <Page
          key={ i }
          data-page-number={ i }
          className={ classes.page }
          pageNumber={ i }
          scale={ scale }
        />
      )
    }
    return newPages
  }, [pageTotal, scale])

  // scroll to current page
  useLayoutEffect(() => {
    if (containerRef.current == null) return
    const firstPageElement = containerRef.current.querySelector(`.${ classes.page }[data-page-number="1"]`)
    const secondPageElement = containerRef.current.querySelector(`.${ classes.page }[data-page-number="${ pageNumber }"]`)
    if (firstPageElement == null || secondPageElement == null) return

    const firstTop = firstPageElement.getBoundingClientRect().top
    const secondTop = secondPageElement.getBoundingClientRect().top
    const deltaHeight = secondTop - firstTop
    if (Number.isNaN(deltaHeight)) return
    containerRef.current.scrollTop = deltaHeight
  }, [pageNumber])

  return (
    <div
      ref={ containerRef }
      className={ classes.viewerContainer }
      tabIndex={ 0 }
    >
      <div className={ cn(classes.viewer, classes.pdfViewer) } >
        <Document
          file={ fileUrl }
          onLoadError={ props.onLoadError }
          onLoadSuccess={ props.onDocumentLoadSuccess }
        >
          { pages }
        </Document>
      </div>
    </div >
  )
}
